import { computed } from 'vue';
import moment from 'moment-timezone';
import { useStore } from '@/store';
import { useAcl } from './useAcl';
import { AclRole } from '@/services/models/Enums';

export type PaymentCardStatus = 'no-card' | 'card-expired' | 'card-expiring' | 'success';

export const usePaymentStatus = () => {
  const store = useStore();
  const { userRole } = useAcl();

  const cardStatus = computed((): PaymentCardStatus => {
    const user = store.user;
    if (!user) return 'no-card';
    const { cardExpiry } = user;
    if (!cardExpiry) return 'no-card';
    if (moment(cardExpiry).unix() <= moment().unix()) return 'card-expired';
    if (moment(cardExpiry).subtract(1, 'month').unix() <= moment().unix()) return 'card-expiring';
    return 'success';
  });

  const isPaymentIssue = computed(
    () =>
      Boolean(store.user?.cardExpiry) &&
      userRole.value === AclRole.user &&
      cardStatus.value !== 'success',
  );

  const cardExpiryDate = computed(() => {
    const user = store.user;
    if (!user) return '';
    const { cardExpiry } = user;
    if (!cardExpiry) return '';
    return moment(cardExpiry).format('D MMM');
  });

  return {
    cardStatus,
    isPaymentIssue,
    cardExpiryDate,
  };
};
